var map = {
	"./star-light.png": "29dc",
	"./star1-grey.png": "8211",
	"./star1-yellow.png": "88c0",
	"./star2-grey.png": "95ed",
	"./star2-yellow.png": "0396",
	"./star3-grey.png": "f13c",
	"./star3-yellow.png": "d8c4",
	"./star4-grey.png": "a519",
	"./star4-yellow.png": "7bfa",
	"./star5-grey.png": "f15f",
	"./star5-yellow.png": "9788"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "26f6";